export default {
  en: "EN",          // English
  de: "DE",          // Deutsch (German)
  es: "ES",          // Español (Spanish)
  nl: "NL",          // Nederlands (Dutch)
  zh: "中文"          // Chinese
}
